export default __webpack_public_path__ + "static/media/yellow-1.11437d23.svg";